import { AuditOutlined } from "@ant-design/icons";
import { Badge, Button } from "antd";
import { useAppDispatch, useAppSelector } from "hooks";
import React from "react";
import { getUserSearchDataObjectsPermissionRequest } from "store/dataObjectDuplicateSearch/actions";
import { getGoldenStewardshipPermissionRequest } from "store/goldenNominal/actions";
import { getReviewQueueCountsRequest } from "store/reviewQueue/actions";
import CypressTestIds from "../../../cypress/CypressTestIds";

interface IReviewQueueButtonProps {
    businessAreaId: string;
    schemaId: string;
    onOpen: () => void;
}

// Opens a schema's golden-record review queue, with its open-item count. Shown only to those the
// queue is open to, as the duplicates service decides: goldenstewardship review, or dataobjectsearch
// view; the count is only asked for then.
const ReviewQueueButton = ({ businessAreaId, schemaId, onOpen }: IReviewQueueButtonProps) => {
    const dispatch = useAppDispatch();
    const canReview = useAppSelector((state) => state.goldenNominal.goldenStewardshipPermission.canReview);
    const canSearch = useAppSelector((state) => !!state.dataObjectDuplicateSearch.userSearchDataObjectsPermision?.canView);
    const counts = useAppSelector((state) => state.reviewQueue.counts);
    const allowed = canReview || canSearch;

    React.useEffect(() => {
        dispatch(getGoldenStewardshipPermissionRequest());
        dispatch(getUserSearchDataObjectsPermissionRequest());
    }, [dispatch]);

    React.useEffect(() => {
        if (allowed) {
            dispatch(getReviewQueueCountsRequest(businessAreaId, schemaId));
        }
    }, [dispatch, allowed, businessAreaId, schemaId]);

    if (!allowed) {
        return null;
    }
    const open = counts && counts.schemaId === schemaId ? counts.open : 0;
    return (
        <Badge count={open} size="small" color="purple">
            <Button onClick={onOpen} aria-label={open > 0 ? `Review queue, ${open} open item${open === 1 ? "" : "s"}` : "Review queue"} data-testid={CypressTestIds.DATASET_LIST_REVIEW_QUEUE_BUTTON}>
                <AuditOutlined aria-hidden /> Review queue
            </Button>
        </Badge>
    );
};

export default ReviewQueueButton;
